'use es6';

import actionTypes from 'ContentEditorUI/redux/actions/inpageActionTypes';

// Note, these are not treated as real Redux actions. They are structured like actions,
// but they will be received as post message events in the parent.
// More info in inpageActionTypes.js

export const showEditForm = widgetName => {
  return {
    type: actionTypes.SHOW_EDIT_FORM,
    widgetName
  };
};
const makeUpdateWidget = type => (id, value, bodyHeight, {
  metaData,
  undoData,
  selectedSmartRuleId,
  matchingSmartObjectIndex,
  isSmartContentPreview,
  updateEditVersion
}) => {
  metaData.inlineEdited = true;
  return {
    type,
    id,
    value,
    bodyHeight,
    metaData,
    undoData,
    needsResponse: true,
    selectedSmartRuleId,
    matchingSmartObjectIndex,
    isSmartContentPreview,
    updateEditVersion
  };
};
export const updateWidget = makeUpdateWidget(actionTypes.UPDATE_WIDGET);
export const mergeModuleBody = makeUpdateWidget(actionTypes.INPAGE_MERGE_MODULE_BODY);
export const widgetUpdatePending = () => {
  return {
    type: actionTypes.WIDGET_UPDATE_PENDING
  };
};
export const updateModuleMetaData = (id, metaData) => {
  return {
    type: actionTypes.UPDATE_MODULE_META_DATA,
    id,
    metaData
  };
};
export const updateComputedStylesForSelectors = computedStylesBySelector => {
  return {
    type: actionTypes.UPDATE_COMPUTED_STYLES_FOR_SELECTORS,
    computedStylesBySelector
  };
};